import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { fromInt2ii0rejb1w62w as fromInt } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  _UInt___init__impl__l7qpdl2xbmh7to8lpd7 as _UInt___init__impl__l7qpdl,
  UInt__toString_impl_dbgl211hnbf9xsikfsf as UInt__toString_impl_dbgl21,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/UInt.mjs';
import {
  _ULong___init__impl__c78o9k4z3cjzifecv6 as _ULong___init__impl__c78o9k,
  ULong__toString_impl_f9au7k3n8y2imw2kac3 as ULong__toString_impl_f9au7k,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/ULong.mjs';
import {
  _UByte___init__impl__g9hnc43bwrjlqz9k9id as _UByte___init__impl__g9hnc4,
  UByte__toString_impl_v72jg35cd2pgynmah7 as UByte__toString_impl_v72jg,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/UByte.mjs';
import {
  _UShort___init__impl__jigrne3vu9egv7mch1k as _UShort___init__impl__jigrne,
  UShort__toString_impl_edaoee1ut8mfnxr9a1q as UShort__toString_impl_edaoee,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/UShort.mjs';
import { _Char___init__impl__6a9atx2gndcvjvc5pke as _Char___init__impl__6a9atx } from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ComposerClass;
function Composer() {
  if (ComposerClass === VOID) {
    class $ {
      constructor(writer) {
        this.y2p_1 = writer;
        this.z2p_1 = true;
      }
      a2q() {
        this.z2p_1 = true;
      }
      b2q() {
        return Unit_instance;
      }
      c2q() {
        this.z2p_1 = false;
      }
      d2q() {
        this.z2p_1 = false;
      }
      e2q() {
        return Unit_instance;
      }
      f2q(v) {
        return this.y2p_1.g2q(v);
      }
      h2q(v) {
        return this.y2p_1.i2q(v);
      }
      j2q(v) {
        return this.y2p_1.i2q(v.toString());
      }
      k2q(v) {
        return this.y2p_1.i2q(v.toString());
      }
      l2q(v) {
        return this.y2p_1.m2q(fromInt(v));
      }
      n2q(v) {
        return this.y2p_1.m2q(fromInt(v));
      }
      o2q(v) {
        return this.y2p_1.m2q(fromInt(v));
      }
      p2q(v) {
        return this.y2p_1.m2q(v);
      }
      q2q(v) {
        return this.y2p_1.i2q(v.toString());
      }
      r2q(value) {
        return this.y2p_1.s2q(value);
      }
    }
    initMetadataForClass($, 'Composer');
    ComposerClass = $;
  }
  return ComposerClass;
}
function Composer_0(sb, json) {
  return json.f2m_1.u2n_1 ? new (ComposerWithPrettyPrint())(sb, json) : new (Composer())(sb);
}
var ComposerForUnsignedNumbersClass;
function ComposerForUnsignedNumbers() {
  if (ComposerForUnsignedNumbersClass === VOID) {
    class $ extends Composer() {
      constructor(writer, forceQuoting) {
        super(writer);
        this.v2q_1 = forceQuoting;
      }
      o2q(v) {
        if (this.v2q_1) {
          // Inline function 'kotlin.toUInt' call
          var tmp$ret$0 = _UInt___init__impl__l7qpdl(v);
          this.r2q(UInt__toString_impl_dbgl21(tmp$ret$0));
        } else {
          // Inline function 'kotlin.toUInt' call
          var tmp$ret$1 = _UInt___init__impl__l7qpdl(v);
          this.h2q(UInt__toString_impl_dbgl21(tmp$ret$1));
        }
      }
      p2q(v) {
        if (this.v2q_1) {
          // Inline function 'kotlin.toULong' call
          var tmp$ret$0 = _ULong___init__impl__c78o9k(v);
          this.r2q(ULong__toString_impl_f9au7k(tmp$ret$0));
        } else {
          // Inline function 'kotlin.toULong' call
          var tmp$ret$1 = _ULong___init__impl__c78o9k(v);
          this.h2q(ULong__toString_impl_f9au7k(tmp$ret$1));
        }
      }
      l2q(v) {
        if (this.v2q_1) {
          // Inline function 'kotlin.toUByte' call
          var tmp$ret$0 = _UByte___init__impl__g9hnc4(v);
          this.r2q(UByte__toString_impl_v72jg(tmp$ret$0));
        } else {
          // Inline function 'kotlin.toUByte' call
          var tmp$ret$1 = _UByte___init__impl__g9hnc4(v);
          this.h2q(UByte__toString_impl_v72jg(tmp$ret$1));
        }
      }
      n2q(v) {
        if (this.v2q_1) {
          // Inline function 'kotlin.toUShort' call
          var tmp$ret$0 = _UShort___init__impl__jigrne(v);
          this.r2q(UShort__toString_impl_edaoee(tmp$ret$0));
        } else {
          // Inline function 'kotlin.toUShort' call
          var tmp$ret$1 = _UShort___init__impl__jigrne(v);
          this.h2q(UShort__toString_impl_edaoee(tmp$ret$1));
        }
      }
    }
    initMetadataForClass($, 'ComposerForUnsignedNumbers');
    ComposerForUnsignedNumbersClass = $;
  }
  return ComposerForUnsignedNumbersClass;
}
var ComposerForUnquotedLiteralsClass;
function ComposerForUnquotedLiterals() {
  if (ComposerForUnquotedLiteralsClass === VOID) {
    class $ extends Composer() {
      constructor(writer, forceQuoting) {
        super(writer);
        this.y2q_1 = forceQuoting;
      }
      r2q(value) {
        if (this.y2q_1) {
          super.r2q(value);
        } else {
          super.h2q(value);
        }
      }
    }
    initMetadataForClass($, 'ComposerForUnquotedLiterals');
    ComposerForUnquotedLiteralsClass = $;
  }
  return ComposerForUnquotedLiteralsClass;
}
var ComposerWithPrettyPrintClass;
function ComposerWithPrettyPrint() {
  if (ComposerWithPrettyPrintClass === VOID) {
    class $ extends Composer() {
      constructor(writer, json) {
        super(writer);
        this.b2r_1 = json;
        this.c2r_1 = 0;
      }
      a2q() {
        this.z2p_1 = true;
        this.c2r_1 = this.c2r_1 + 1 | 0;
      }
      b2q() {
        this.c2r_1 = this.c2r_1 - 1 | 0;
      }
      c2q() {
        this.z2p_1 = false;
        this.h2q('\n');
        // Inline function 'kotlin.repeat' call
        var times = this.c2r_1;
        var inductionVariable = 0;
        if (inductionVariable < times)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            this.h2q(this.b2r_1.f2m_1.w2n_1);
          }
           while (inductionVariable < times);
      }
      d2q() {
        if (this.z2p_1)
          this.z2p_1 = false;
        else {
          this.c2q();
        }
      }
      e2q() {
        this.f2q(_Char___init__impl__6a9atx(32));
      }
    }
    initMetadataForClass($, 'ComposerWithPrettyPrint');
    ComposerWithPrettyPrintClass = $;
  }
  return ComposerWithPrettyPrintClass;
}
//region block: exports
export {
  ComposerForUnquotedLiterals as ComposerForUnquotedLiterals3v0rwxdudtla9,
  ComposerForUnsignedNumbers as ComposerForUnsignedNumbers2h1dv6l9z3aef,
  Composer_0 as Composer1pt8hwk95abxi,
};
//endregion

//# sourceMappingURL=Composers.mjs.map
